import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/IBMPlexSerif-LightItalic-latin.woff2%22,%22weight%22:%22300%22,%22style%22:%22italic%22},{%22path%22:%22../../public/fonts/IBMPlexSerif-Italic-latin.woff2%22,%22weight%22:%22400%22,%22style%22:%22italic%22}],%22variable%22:%22--font-first-run-serif%22,%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:%22Times%20New%20Roman%22}],%22variableName%22:%22firstRunSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'firstRunSerif', 'firstRunSerif Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
